<template>
  <v-card class="pt-8 fill-height" :class="`${cardType}-card`">
    <v-card-text class="text-center">
      <div v-if="loading">
        <vue-content-loading>
          <rect y="0px" width="100%" height="50px" />
          <rect y="80px" width="100%" height="50px" />
        </vue-content-loading>
      </div>

      <div v-else class="mt-6">
        <h1>{{ value }}<mf-quick-actions v-if="quickActionsProps" v-bind="quickActionsProps" /></h1>
        <div class="text-container">
          <p>{{ label }}</p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'NotReceivedCampaignCard',
  components: {
    VueContentLoading,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      required: true,
    },
    quickActionsProps: {
      type: Object,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.secondary-card {
  & h1 {
    color: $marca-1;
    margin-bottom: 16px;
    font-size: 36px;
    font-weight: 700;
    line-height: 120%;
  }
  & .text-container {
    & p {
      max-width: 250px;
      font-size: 18px;
      color: $cinza-0;
      font-weight: normal;
      line-height: 120%;
      text-align: center;
    }
  }
}

.primary-card {
  background-color: $marca-1;
  & h1 {
    color: $branco;
    margin-bottom: 16px;
    font-size: 36px;
    font-weight: 700;
    line-height: 120%;
  }
  & .text-container {
    display: flex;
    justify-content: center;
    & p {
      max-width: 250px;
      font-size: 18px;
      color: $branco;
      font-weight: normal;
      line-height: 120%;
      text-align: center;
    }
  }
}
</style>
